import type { ExamTypeConfig } from '@examflow/core';
import { registerExamQuestionTypes } from '@examflow/core';
import { IELTS_SECTIONS } from './sections';
import { ieltsScoringRules } from './scoring';
import { IELTS_QUESTION_TYPE_DEFINITIONS } from './questionTypes';

/**
 * IELTS 考试完整配置
 */
export const ieltsExamConfig: ExamTypeConfig = {
  id: 'ielts',
  name: 'IELTS (International English Language Testing System)',
  description: '雅思考试 - 国际英语语言测试系统，广泛用于留学和移民',
  languageId: 'english',
  questionTypeDefinitions: IELTS_QUESTION_TYPE_DEFINITIONS,
  sections: IELTS_SECTIONS,
  scoringRules: ieltsScoringRules,
};

registerExamQuestionTypes('ielts', Object.values(IELTS_QUESTION_TYPE_DEFINITIONS));

export * from './types';
export * from './levels';
export * from './sections';
export * from './scoring';
export * from './intro';
export * from './questionTypes';
